// Borrador compartido del pedido entre PedidosCreate y PedidosCreateMarket.
// Se guarda en sessionStorage (vive durante la sesión de la pestaña).

const STORAGE_KEY = "pedidoMacuroBorrador";

export const guardarBorradorPedido = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    console.log("No se pudo guardar borrador", e);
  }
};

export const cargarBorradorPedido = () => {
  try {
    const s = sessionStorage.getItem(STORAGE_KEY);
    return s ? JSON.parse(s) : null;
  } catch (e) {
    return null;
  }
};

export const limpiarBorradorPedido = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
};
